import { render, staticRenderFns } from "./commonPoolRegionPage.vue?vue&type=template&id=28ae87fa&scoped=true&"
import script from "./commonPoolRegionPage.vue?vue&type=script&lang=js&"
export * from "./commonPoolRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./commonPoolRegionPage.vue?vue&type=style&index=0&id=28ae87fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae87fa",
  null
  
)

export default component.exports